// paymentType


import { t, Trans } from '@lingui/macro';
import React from 'react';
import { CashIcon, CreditCardIcon, CurrencyDollarIcon, QrcodeIcon } from '@heroicons/react/outline';

export enum PAYMENTTYPE{
    CASH = 'CASH',
    CARD = 'CARD',
    CASHLESS = 'CASHLESS',
    UZ_CARD = 'UZ_CARD',

    QR = 'QR'

}


export  const getTransPaymentType = (paymentType: string)=>{

    switch (paymentType) {
        case PAYMENTTYPE.CASH:
            return <Trans>by cash</Trans>
        case PAYMENTTYPE.CARD:
            return <Trans>by card</Trans>
        case PAYMENTTYPE.UZ_CARD:
            return <Trans>by card</Trans>
        case PAYMENTTYPE.CASHLESS:
            return <Trans>by other cashless</Trans>
        case PAYMENTTYPE.QR:
            return <Trans>by qr-code</Trans>
        default: return paymentType
    }
}

export  const getStringPaymentType = (paymentType: string)=>{

    switch (paymentType) {
        case PAYMENTTYPE.CASH:
            return t`by cash`
        case PAYMENTTYPE.CARD:
            return t`by card`
        case PAYMENTTYPE.UZ_CARD:
            return t`by card`
        case PAYMENTTYPE.CASHLESS:
            return t`by other cashless`
        case PAYMENTTYPE.QR:
            return t`by qr-code`
        default: return paymentType
    }
}


export  const getIconPaymentType = (paymentType: string)=>{

    switch (paymentType) {
        case PAYMENTTYPE.CASH:
            return <CashIcon className={"w-5 h-5"}/>
        case PAYMENTTYPE.CARD:
            return <CreditCardIcon  className={"w-5 h-5"}/>
        case PAYMENTTYPE.UZ_CARD:
            return <CreditCardIcon  className={"w-5 h-5"}/>
        case PAYMENTTYPE.CASHLESS:
            return <CurrencyDollarIcon className={"w-5 h-5"}/>
        case PAYMENTTYPE.QR:
            return <QrcodeIcon className={"w-5 h-5"}/>
        default: return paymentType
    }
}
